import styled, { keyframes } from 'styled-components';
import { palette } from 'styled-tools';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const rotate = keyframes`
  from { 
    transform: rotate(0deg) 
  }
  to { 
    transform: rotate(360deg) 
  }
`;

export const LoadingIcon = styled.div`
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid ${palette('primary')};
  border-top-width: 0;
  border-left-width: 0;
  animation: ${rotate} 1s linear infinite;
`;
